import {
  CART_ITEM_TYPES,
  SUB_CART_ITEM_TYPES,
} from 'hb-react/shared/components/ShoppingCard/constants/cartConstants';

export const initCart = ({ valuesStep1, event }) => {
  const { tickets } = event;
  const { currency } = valuesStep1.tickets.find(
    (ticket) => ticket.quantity > 0,
  );

  const cartTickets = valuesStep1.tickets
    .map((cartTicket) => {
      const eventTicket =
        tickets.find((ticket) => ticket.id === cartTicket.id) || {};

      const quantity = parseInt(cartTicket.quantity, 10);

      return Array.from({ length: quantity }).map((_) => ({
        type: CART_ITEM_TYPES.TICKET,
        line_itemable_id: cartTicket.id,
        quantity: 1,
        metadata: {
          event: {
            ...eventTicket,
            ticket_id: cartTicket.id,
            type: SUB_CART_ITEM_TYPES.TICKET,
          },
        },
      }));
    })
    .flat();

  return {
    cart: {
      currency,
      cart_items: cartTickets,
    },
  };
};
